const mutations = { 
  setApps(state, data) {
    state.appsData = data;
  },    
  setFilterTerm(state, term) {
    state.filters.term = term;
  },   
  clearFilterTerm(state) {
    state.filters.term = '';
  },   
  setFilterCategoryId(state, id) {
    if (state.filters.category_id === id) id = null; 
    state.filters.category_id = id;
  }    
}

export default mutations;
  